import { FC } from 'react';
import { Avatar } from 'antd';
import { AvatarSize } from 'antd/es/avatar/AvatarContext';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import type { CompactActiveAvatarCollaborator } from '@/shared/components/groups/CompactActiveAvatarGroup';

import ActiveAvatarItem from './ActiveAvatarItem';

interface ActiveAvatarsProps {
    collaborators: readonly CompactActiveAvatarCollaborator[];
    resourceId?: string;
    marginRight?: string;
    bottom?: number;
    right?: number;
    tooltipPlacement?:
        | 'bottom'
        | 'topLeft'
        | 'topCenter'
        | 'topRight'
        | 'bottomLeft'
        | 'bottomCenter'
        | 'bottomRight'
        | 'top'
        | undefined;
    type?: 'investment' | 'team' | undefined; // It'd be great if we didn't have to do this
    size?: AvatarSize; // It'd be great if we didn't have to do this
}

const ActiveAvatars: FC<ActiveAvatarsProps> = ({
    collaborators,
    resourceId,
    marginRight,
    bottom,
    right,
    tooltipPlacement,
    type = 'investment',
    size,
}): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <>
            {collaborators?.length !== 0 && (
                <Avatar.Group
                    style={{
                        borderColor: token.colorBgBase,
                        backgroundColor: 'transparent',
                        bottom,
                        right,
                        marginRight,
                    }}
                    max={{
                        count: 3,
                        style: {
                            color: token.colorBgBase,
                            borderColor: token.colorBgBase,
                            backgroundColor: 'transparent',
                            fontSize: '0.75rem',
                            lineHeight: '1.75rem',
                        },
                    }}
                    size={size ?? 'default'}
                >
                    {collaborators?.map((collaborator) => {
                        return (
                            <ActiveAvatarItem
                                key={collaborator?.id}
                                collaborator={collaborator}
                                resourceId={resourceId}
                                size={size}
                                tooltipPlacement={tooltipPlacement}
                                type={type}
                            />
                        );
                    })}
                </Avatar.Group>
            )}
        </>
    );
};

export default ActiveAvatars;
